const texts = {
  title: 'Programs',
  addNewProgram: 'Add Program',
  program: 'Program',
  noOptionText: 'No program found...',
  textFieldLabel: 'Select Program',
  deleteConfirmMsg: 'Are you sure you want to remove Program {programIndex}?',
  repeatCountLabel: 'Repeat count',
};

export default texts;
